var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loading_bg_wrap"}),_c('div',{staticClass:"loading_wrap"},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.text)+"...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }